import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import isFunction from 'lodash/isFunction';
import { selectTopProps } from '../../selectors';
import { selectAvailableMethods } from '../../selectors/payment';

/**
 * Custom hook to trigger onPaymentMethodsAmountInit callback
 */
export const useOnPaymentMethodsAmountInit = () => {
  const { orderItems, onPaymentMethodsAmountInit } = useSelector(selectTopProps, (prev, next) => {
    return isEqual(prev.orderItems, next.orderItems);
  });
  const availableMethods = useSelector(selectAvailableMethods);

  useEffect(() => {
    if (isFunction(onPaymentMethodsAmountInit)) {
      onPaymentMethodsAmountInit(availableMethods.length);
    }
  }, [orderItems, availableMethods]);
};
